module.exports = __webpack_public_path__ + "static/media/TransformationServices.067f082f.svg";